<div
  class="group flex flex-row items-center px-3 soft-card shadow rounded-lg flex-nowrap cursor-pointer"
  (click)="goToApplication(application)"
>
  <span
    class="application-icon rounded-xl min-w-16 min-h-16 text-center items-center content-center justify-center"
    [class]="
      showColor() && application?.color && !application?.disabled
        ? application?.color
        : 'bg-surface-tertiary dark:bg-surface-muted text-color'
    "
  >
    @if (application?.icon !== '') {
      <soft-icon
        [name]="application?.icon"
        class="fa-2x"
        [class]="application?.disabled ? 'text-lighter' : ''"
      ></soft-icon>
    } @else {
      <i class="fa-regular fa-ban fa-3x"></i>
    }
  </span>
  <div class="flex flex-col w-full ml-3">
    <span
      class="font-bold text-xl"
      [class]="application?.disabled ? 'text-lighter' : ''"
      >{{ application?.name | translate }}</span
    >

    @if (application?.description) {
      <p class="color-light">
        {{ application?.description | translate }}
      </p>
    }
  </div>
  <div class="flex flex-row justify-center items-center p-2 gap-1">
    @if (canPin()) {
      <button
        type="button"
        class="opacity-0 group-hover:opacity-100 flex items-center justify-center size-8 rounded-md hover:bg-surface-tertiary transition-opacity cursor-pointer"
        [class.opacity-100]="pinned()"
        [class.text-primary]="pinned()"
        (click)="pinChange.emit(!pinned()); $event.stopPropagation()"
        [title]="pinned() ? 'Aus Navigation entfernen' : 'An Navigation anheften'"
      >
        <i
          class="fa-thumbtack text-sm transition-transform"
          [class.fa-solid]="pinned()"
          [class.fa-regular]="!pinned()"
          [class.rotate-45]="pinned()"
        ></i>
      </button>
    }
    <button
      type="button"
      class="opacity-0 group-hover:opacity-100 flex items-center justify-center size-8 rounded-md hover:bg-surface-tertiary transition-opacity cursor-pointer"
      (click)="openInNewTab(application, $event)"
      title="In neuem Tab öffnen"
    >
      <i class="fa-regular fa-arrow-up-right-from-square text-sm"></i>
    </button>
  </div>
</div>
